import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  GET_KYC, GET_KYC_SUCCESSFULL,GET_KYC_FAILED,
  GET_KYC_STATUS, GET_KYC_STATUS_SUCCESSFULL, GET_KYC_STATUS_FAILED,
  GET_PROFILE
  ,GET_PROFILE_SUCCESSFUL,GET_PROFILE_FAILED
} from "./actionTypes"

export const registerUser = (user, callback) => {

  return {
    type: REGISTER_USER,
    payload: { user, callback },
  }
}

export const registerUserSuccessful = user => {
  return {
    type: REGISTER_USER_SUCCESSFUL,
    payload: user,
  }
}

export const registerUserFailed = user => {
  return {
    type: REGISTER_USER_FAILED,
    payload: user,
  }
}


export const getKyc = (user, callback) => {
  return {
    type: GET_KYC,
    payload: { user, callback },
  }
}

export const getKycSuccessful = user => {
  return {
    type: GET_KYC_SUCCESSFULL,
    payload: user,
  }
}

export const getKycFail = user => {
  return {
    type: GET_KYC_FAILED,
    payload: user,
  }
}

export const getKycStatus = (user, callback) => {
  return {
    type: GET_KYC_STATUS,
    payload: { user, callback },
  }
}

export const getKycStatusSuccessful = user => {

  return {
    type: GET_KYC_STATUS_SUCCESSFULL,
    payload: user,
  }
}

export const getKycStatusFail = user => {
  return {
    type: GET_KYC_STATUS_FAILED,
    payload: user,
  }
}

export const getProfile = (data, callback) => {
  return {
    type: GET_PROFILE,
    payload: { data, callback },
  }
}

export const getProfileSuccessful = data => {
  return {
    type: GET_PROFILE_SUCCESSFUL,
    payload: data,
  }
}

export const getProfileFail = data => {
  return {
    type: GET_PROFILE_FAILED,
    payload: data,
  }
}